




































































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeLivraison, {LivraisonFilter} from '@/stores/modules/livraison';
import storeTransporteur from "@/stores/modules/transporteur";

import InputDateFilter from '@/components/Input/DateFilter.vue';
import CrudClientSearch from "@/components/Crud/Client/Search.vue";
import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputLongueursVente from "@/components/Input/LongueursVente.vue";
import {DateFilterMode} from "@/shared/filter";
import storeLongueursAchat from '@/stores/modules/longueursAchat';
import storeBoisType from '@/stores/modules/boisType';

@Component({
	components: {
		InputDateFilter,
		CrudClientSearch,
		InputBoisType,
		InputLongueursVente,
		CrudTransporteurSearch,
	}
})
export default class CrudLivraisonFilter extends Vue {

	@Prop({ type: Boolean, default: false}) reduce!: boolean;

	@Stored(() => storeLivraison) private page!: number;
	@Stored(() => storeLivraison) private filters!: LivraisonFilter;

	private storeBoisType = storeBoisType
	private storeLongueursAchat = storeLongueursAchat

	private valueBoisType = null;
	private valueLongueursAchat = null;

	@WatchObjectProperties('filters', LivraisonFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeLivraison.dispatch('getC', { filters: true });
	}

	public async mounted(): Promise<void> {
		await storeBoisType.dispatch('getAll');
		this.valueBoisType = storeBoisType.state.all.data
		await storeLongueursAchat.dispatch('getAll');
		this.valueLongueursAchat = storeLongueursAchat.state.all.data
		this.typeWatcher();
		this.filters = new LivraisonFilter();
		var dt = new Date();
		dt.setDate(dt.getDate() - 30);
		this.filters.date.start = dt;
		this.filters.date.end = new Date();
		this.filters.date.mode = DateFilterMode.RANGE;
	}

	@Watch('type')
	private typeWatcher(): void {
		this.filters.clear();

	}

}
